import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useMemo } from 'react';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
import { useNetworkOptions } from '@/modules/workstream/hooks/use-network-options';
interface NetworkSelectProps {
  networks: string[];
  setNetworks: (networks: string[]) => Promise<URLSearchParams>;
  className?: string;
}
function NetworkSelect(t0) {
  const $ = _c(16);
  const {
    networks,
    setNetworks,
    className
  } = t0;
  let t1;
  if ($[0] !== setNetworks) {
    t1 = options => {
      const values = options.map(_temp);
      setNetworks(values);
    };
    $[0] = setNetworks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  const {
    options: options_0,
    isLoadingAllNetworks
  } = useNetworkOptions();
  let t2;
  if ($[2] !== networks || $[3] !== options_0) {
    let t3;
    if ($[5] !== networks) {
      t3 = option_0 => networks.includes(option_0.value);
      $[5] = networks;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = options_0.filter(t3);
    $[2] = networks;
    $[3] = options_0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectedOptions = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("bg-background dark:bg-background");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== className) {
    t4 = {
      className
    };
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleChange || $[11] !== isLoadingAllNetworks || $[12] !== options_0 || $[13] !== selectedOptions || $[14] !== t4) {
    t5 = <MultipleSelector value={selectedOptions} onChange={handleChange} options={options_0} enableSearch={false} groupBy="group" enableSelectAll={true} selectAllGroup="Networks" placeholder="All Networks" className={t3} disabled={isLoadingAllNetworks} commandProps={t4} />;
    $[10] = handleChange;
    $[11] = isLoadingAllNetworks;
    $[12] = options_0;
    $[13] = selectedOptions;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function _temp(option) {
  return option.value;
}
export { NetworkSelect };
export type { NetworkSelectProps };